module.exports = __webpack_public_path__ + "img/project_participation.d08da5d0.jpg";